import { render, staticRenderFns } from "./imageText.edit.vue?vue&type=template&id=4f5d474a&scoped=true"
import script from "./imageText.edit.vue?vue&type=script&lang=js"
export * from "./imageText.edit.vue?vue&type=script&lang=js"
import style0 from "./imageText.edit.vue?vue&type=style&index=0&id=4f5d474a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d474a",
  null
  
)

export default component.exports